<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-text-field
        box
        :hint="fieldHint"
        :disabled="readonly"
        :label="fieldLabel"
        :rules="activeRules"
        :placeholder="placeholder"
        :type="passwordVisible ? 'text' : 'password'"
        :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
        @click:append="passwordVisible = !passwordVisible"
        v-on:blur="blurred()"
        v-model="text"
        autocomplete="new-password"
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"

export default {
  name: "password-field",
  data: () => ({
    passwordVisible: false,
    rules: {
      required: value => !!value || "Required."
    }
  }),
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    },
    newCase: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    blurred() {
      this.$emit("blurred", {
        field: this.field.name,
        data: this.text,
        row: this.row
      })
    }
  },
  computed: {
    activeRules() {
      const results = []
      if (this.field.required && this.newCase) {
        results.push(this.rules.required)
      }
      return results
    },
    fieldLabel() {
      return this.field.display_name
        ? this.field.display_name
        : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    fieldHint() {
      if (this.field.guidance) {
        return this.field.guidance
      }
      if (!this.newCase) {
        return "Leave blank to keep the current password"
      }
      return ""
    },
    placeholder() {
      if (!this.newCase) {
        return "Leave blank to keep current password"
      }
      return ""
    },
    text: {
      get() {
        if (this.data) {
          return this.data
        }
        if (this.newCase && this.field && this.field.default_value) {
          return this.field.default_value
        }
        return ""
      },
      set(value) {
        this.$emit("update-item", {
          field: this.field.name,
          data: value,
          row: this.row
        })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) {
        readonly = this.field.readonly
      }
      return readonly
    }
  }
}
</script>
